import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import SolarPowerOutlinedIcon from "@mui/icons-material/SolarPowerOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import { Box, Grid, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { TRACKING_CARD_PURPLE_SX } from "./trackingStyles";

const KpiTile = ({ label, value, highlight = false }) => (
  <Box
    sx={{
      p: { xs: 1.25, sm: 1.5 },
      borderRadius: 2,
      height: "100%",
      bgcolor: highlight ? undefined : "grey.50",
      ...(highlight && {
        background: (t) =>
          t.palette.mode === "dark"
            ? t.palette.secondary.dark
            : "linear-gradient(135deg, #7E57C2 0%, #5E35B1 100%)",
        color: "common.white",
      }),
    }}
  >
    <Typography
      variant="caption"
      display="block"
      sx={{
        mb: 0.5,
        color: highlight ? "inherit" : "text.secondary",
        opacity: highlight ? 0.92 : 1,
        lineHeight: 1.3,
      }}
    >
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={700} sx={{ lineHeight: 1.4 }}>
      {value}
    </Typography>
  </Box>
);

KpiTile.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  highlight: PropTypes.bool,
};

const RequestEstimatedIncomeCard = ({ income }) => {
  if (!income?.available) return null;

  const offGrid = Boolean(income.offGridNote);

  return (
    <Box sx={{ ...TRACKING_CARD_PURPLE_SX, p: { xs: 2, md: 2.5 } }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
        <MonetizationOnOutlinedIcon sx={{ color: "#7E57C2" }} />
        <Typography variant="subtitle1" fontWeight={800} sx={{ color: "#5E35B1" }}>
          برآورد درآمد نیروگاه
        </Typography>
      </Stack>

      <Grid container spacing={1.5}>
        <Grid item xs={6} sm={3}>
          <KpiTile label="نوع نیروگاه" value={income.plantTypeKpi || "—"} />
        </Grid>
        {offGrid ? (
          <Grid item xs={12} sm={9}>
            <Box
              sx={{
                p: 1.5,
                borderRadius: 2,
                bgcolor: "grey.50",
                height: "100%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Stack direction="row" spacing={1} alignItems="flex-start">
                <SolarPowerOutlinedIcon sx={{ color: "text.secondary", fontSize: 20 }} />
                <Typography variant="body2" color="text.secondary" lineHeight={1.65}>
                  {income.offGridNote}
                </Typography>
              </Stack>
            </Box>
          </Grid>
        ) : (
          <>
            <Grid item xs={6} sm={3}>
              <KpiTile
                label="درآمد ماهانه تخمینی"
                value={income.monthlyIncomeFormatted}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <KpiTile
                label="درآمد سالانه تخمینی"
                value={income.annualIncomeFormatted}
                highlight
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <KpiTile
                label="قرارداد خرید تضمینی"
                value={`${income.contractYears.toLocaleString("fa-IR")} سال`}
              />
            </Grid>
          </>
        )}
      </Grid>

      <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ mt: 2 }}>
        <TrendingUpOutlinedIcon sx={{ fontSize: 18, color: "text.secondary", mt: 0.25 }} />
        <Typography variant="caption" color="text.secondary" lineHeight={1.55}>
          {income.disclaimer}
        </Typography>
      </Stack>
    </Box>
  );
};

RequestEstimatedIncomeCard.propTypes = {
  income: PropTypes.object.isRequired,
};

export default RequestEstimatedIncomeCard;
